import React, { useState, useEffect, useRef } from "react";
import "./Home.css";
import { Helmet } from "react-helmet";
import { UpOutlined } from "@ant-design/icons";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

import Index from "../Others/Index";
import Services from "../Others/Services";
import Skills from "../Others/Skills";
import Experience from "../Others/Experience";
import Projects from "../Others/Projects";
import Testimonial from "../Others/Testimonial";
import FavouriteClients from "../Others/FavouriteClients";
import BlogPost from "../Others/BlogPost";
import WorkingPlan from "../Others/WorkingPlan";
import ContactMe from "../Others/ContactMe";
import Technology from "../Others/Technology";

export default function Home() {
  const [showHeader, setShowHeader] = useState(false);
  const [showGoTopButton, setShowGoTopButton] = useState(false);

  useEffect(() => {
    let prevScrollPos = window.pageYOffset;
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrolledDown = prevScrollPos < currentScrollPos;
      const isScrollOverThreshold = currentScrollPos > window.innerHeight;

      setShowHeader(!(isScrolledDown && isScrollOverThreshold));
      setShowGoTopButton(currentScrollPos > 500); // Adjust the threshold as needed
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const topRef = useRef(null);

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>Tasnim Shahriar Akash | MERN Stack Developer Portfolio</title>

        <meta
          name="description"
          content="Tasnim Shahriar Akash is a professional MERN Stack developer from Bangladesh, specializing in React.js, Node.js, modern web applications, and UI/UX design."
        />

        <meta
          name="keywords"
          content="Tasnim Shahriar Akash, MERN Stack Developer, React Developer, Node.js Developer, Full Stack Developer Bangladesh, Web Developer Portfolio"
        />

        <meta name="author" content="Tasnim Shahriar Akash" />

        {/* Open Graph (Facebook / LinkedIn) */}
        <meta
          property="og:title"
          content="Tasnim Shahriar Akash | MERN Stack Developer"
        />
        <meta
          property="og:description"
          content="Explore the portfolio of Tasnim Shahriar Akash, a skilled MERN Stack developer building modern and scalable web applications."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tasnim-s-akash.web.app" />
        <meta
          property="og:image"
          content="https://tasnim-s-akash.web.app/preview.png"
        />

        {/* Twitter SEO */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Tasnim Shahriar Akash | MERN Developer"
        />
        <meta
          name="twitter:description"
          content="MERN Stack Developer specializing in React, Node.js, and modern UI/UX design."
        />
        <meta
          name="twitter:image"
          content="https://tasnim-s-akash.web.app/preview.png"
        />

        {/* Mobile + Charset */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />
      </Helmet>
      <div className="Home-Body">
        <div className="Home-Heder" ref={topRef} id="top">
          <div className={`Home-Heder-Box ${showHeader ? "" : "visible"}`}>
            <Header />
          </div>
        </div>
        <div className="Header">
          <Header />
        </div>
        <Index />
        <Services />
        <Skills />
        <Experience />
        <Projects />
        <Testimonial />
        <FavouriteClients />
        <BlogPost />
        <WorkingPlan />
        <Technology />
        <ContactMe />
        <Footer />
        <button
          className={`Home-goTop-Button ${showGoTopButton ? "show" : ""}`}
          onClick={scrollToTop}
        >
          <UpOutlined />
        </button>
      </div>
    </>
  );
}
